import React from 'react'

import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'

import { PAWSectionType } from './paw-section-types'

export const SalesQuota: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  return (
    <section className="mb-8" data-testid="section-sales-quota">
      <h2 className="mb-6 text-xl font-semibold">Sales Quota Attainment</h2>
      <Card>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">
                  Monthly Quota
                </span>
                <span className="text-sm font-medium">$45,000</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">MTD Sales</span>
                <span className="text-sm font-semibold text-tenant-primary-color">
                  $38,500
                </span>
              </div>
              <div className="relative h-3 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="absolute left-0 top-0 h-full rounded-full bg-tenant-primary-color transition-all"
                  style={{ width: '85.6%' }}
                />
              </div>
              <p className="text-center text-xs text-muted-foreground">
                85.6% of monthly quota
              </p>
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Q1 Quota</span>
                <span className="text-sm font-medium">$135,000</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Q1 Sales</span>
                <span className="text-sm font-semibold text-tenant-primary-color">
                  $98,500
                </span>
              </div>
              <div className="relative h-3 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="absolute left-0 top-0 h-full rounded-full bg-emerald-500 transition-all"
                  style={{ width: '73%' }}
                />
              </div>
              <p className="text-center text-xs text-muted-foreground">
                73% of Q1 quota
              </p>
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">
                  Annual Quota
                </span>
                <span className="text-sm font-medium">$540,000</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">YTD Sales</span>
                <span className="text-sm font-semibold text-tenant-primary-color">
                  $98,500
                </span>
              </div>
              <div className="relative h-3 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="absolute left-0 top-0 h-full rounded-full bg-amber-500 transition-all"
                  style={{ width: '18.2%' }}
                />
              </div>
              <p className="text-center text-xs text-muted-foreground">
                18.2% of annual quota
              </p>
            </div>
          </div>
          <p className="mt-4 text-center text-xs text-muted-foreground">
            Data synced from Salesforce • Last updated: Feb 5, 2026 at 9:15 AM
          </p>
        </CardContent>
      </Card>
    </section>
  )
}
